import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { fmtStackFilterLink } from '../../utils/formatters';

import { BucketIcon } from '.';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function StackIconButton(props) {
  const { name } = props;
  const classes = useStyles();

  const handleGoToStack = () => {
    window.open(fmtStackFilterLink(name),"_blank");
  };

  if(name) {
    return (
      <IconButton className={classes.root} onClick={handleGoToStack}>
        <BucketIcon/>
      </IconButton>
    );
  } else {
    return(null);
  }
}

StackIconButton.propTypes = {
  name: PropTypes.string,
};

StackIconButton.defaultProps = {
};
